import { render, staticRenderFns } from "./PrivacyPolicyRU.vue?vue&type=template&id=b9a7dffe&"
import script from "./PrivacyPolicyRU.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyRU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports